<template>
  <div class="page page-pubblication page-light p-top-header">
    <section>
      <div class="page-team p-bottom-xxxl-2">
        <div v-if="matchMedia" class="page-team__col-left">
          <div
            v-if="page?.image"
            class="page-team__image__wrap"
            data-animate="block-image-preview"
          >
            <WidgetPicture
              class="page-team__image"
              :image="{ custom: page?.image?.responsiveImage }"
              :lazyLoad="true"
              :alt="page.title"
            />
          </div>
          <div class="page-team__details">
            <p v-if="page.linkedin && page.linkedin !== ''" class="text-1">
              <a :href="page.linkedin" target="_blank">Linkedin</a>
            </p>
            <p v-if="page.tel && page.tel !== ''" class="text-1">
              <a :href="`tel:${page.tel.replace(/\s/g, '')}`">
                {{ page.tel }}</a
              >
            </p>
            <p v-if="page.mail && page.mail !== ''" class="text-1">
              <a :href="`mailto:${page.mail.replace(/\s/g, '')}`">
                {{ page.mail }}</a
              >
            </p>
          </div>
        </div>
        <div class="page-team__col-right">
          <header class="page-team__header">
            <h1 class="title-base-mix" v-html="page.name" />
            <p class="text-m-1 is-text-uppercase" v-html="page.role" />
          </header>
          <template v-if="!matchMedia">
            <div
              v-if="page?.image"
              class="page-team__image__wrap"
              data-animate="block-image-preview"
            >
              <WidgetPicture
                class="page-team__image"
                :image="{ custom: page?.image?.responsiveImage }"
                :lazyLoad="true"
                :alt="page.title"
              />
            </div>
            <div class="page-team__details">
              <p v-if="page.linkedin && page.linkedin !== ''" class="text-1">
                <a :href="page.linkedin" target="_blank">Linkedin</a>
              </p>
              <p v-if="page.tel && page.tel !== ''" class="text-1">
                <a :href="`tel:${page.tel.replace(/\s/g, '')}`">
                  {{ page.tel }}</a
                >
              </p>
              <p v-if="page.mail && page.mail !== ''" class="text-1">
                <a :href="`mailto:${page.mail.replace(/\s/g, '')}`">
                  {{ page.mail }}</a
                >
              </p>
            </div>
          </template>
          <div class="page-team__desc text-m-1" v-html="page.bio" />
        </div>
      </div>
    </section>
    <PagesCommonExtraScrollBlock v-if="nextTeam">
      <div class="extra-scroll-block__col --left">
        <p class="is-text-uppercase text-1 ">Keep scrolling<br>
        to discover our</p>
        
           <p class="title-base-mix extra-scroll-block__title"> {{ nextTeam.name}}</p>
       
        
        </div>
        <div class="extra-scroll-block__col --right">
          
          <div class="extra-scroll-block__bar">
            <p class="is-text-uppercase text-1">Scroll to<br>Next page</p>
          <div class="progress-bar"><div ref="progressBar" class="progress-bar-violet" ></div></div>
            <img src="@/assets/img/ico/ico-forward-arrow.svg" alt="Next page" class="extra-scroll-block__icon"/>
          </div>
        </div>
    </PagesCommonExtraScrollBlock>
  </div>
</template>

<script setup>
import { gsap } from 'gsap'
import queries from '@/graphql/dato/queries/index.js'

//import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
 // pageTransition,
})

const { locale } = useI18n()
const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()

const touch = ref(false)
const matchMedia = useHelpers().evalMatchMedia('(min-width: 750px)')

const query = queries.team.getTeam
const variables = computed(() => ({
  locale: locale.value,
  filter: { slug: { eq: route.params.slug } },
}))

const staggeredBlocksShown = ref(false)
const duration = 0.6
const durationFast = 0.4
const ease = 'power2.inOut'

const { data } = await useGraphql(query, variables)

if (!data.value?.team) {
  throw createError({ statusCode: 404 })
}
const page = computed(() => data.value?.team)
const seo = computed(() => data.value?.team?.seo || {})
const allTeams = computed(() => data.value?.allTeams)

//const latestNews = computed(() => data.value?.allNews)
const nextTeam = computed(() => {
  return allTeams.value.find(el => el.position === page.value.position + 1) ? allTeams.value.find(el => el.position === page.value.position + 1) : allTeams.value.find(el => el.position === 1)
  }
)

let extraScroll = 0; // Contatore per lo scroll extra
const SCROLL_THRESHOLD = ref(500) // Soglia di 300 px virtuali
const isTransitioning = ref(false)
const extraScrollPercentage = ref(0)
let touchStartY = 0

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
  window.addEventListener('wheel', handleScroll);
window.addEventListener('touchmove', handleScroll, { passive: false }); // Per dispositivi mobili
 window.addEventListener('touchstart', (event) => {
    touchStartY = event.touches[0].clientY;
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('wheel', handleScroll);
  window.removeEventListener('touchmove', handleScroll);
  window.removeEventListener('touchstart', () => {})
})

onUnmounted(() => {})

// Seo
useSeo({
  ...seo.value,
})

watch(
  () => route.path,
  () => {}
)

const dataFormatted = (date) => {
  const data = new Date(date)
  // Array dei nomi dei mesi in inglese
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const day = data.getDate().toString().padStart(2, '0')
  const month = months[data.getMonth()]
  const year = data.getFullYear()

  const dataFormat = `${day} ${month} ${year}`
  return dataFormat
}

const handleScroll = (event) => {
  const baretta = document.querySelector('.progress-bar-violet')
  //console.log('dentro handleSCroll')
  const scrollPosition = window.innerHeight + window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;

  //console.log(scrollPosition, documentHeight)


  if (scrollPosition >= documentHeight - 5 && !isTransitioning.value) {
    // L'utente è al fondo: registra il movimento di scroll extra
   let scrollDelta = 0;

    // Determina il delta per il movimento del mouse (wheel) o touch (touchmove)
    if (event.type === 'wheel') {
      scrollDelta = event.deltaY; // movimento della rotella del mouse
    } else if (event.type === 'touchmove') {
      const touch = event.touches[0];
    scrollDelta = touchStartY - touch.clientY;
    touchStartY = touch.clientY // movimento del tocco su dispositivi mobili
    }

    if (touch.value) {
      SCROLL_THRESHOLD.value = 100
    }

    // Accumula lo scroll extra
    extraScroll += scrollDelta;
    //console.log(extraScroll, extraScrollPercentage.value)
    extraScrollPercentage.value = Math.min(100, (extraScroll / SCROLL_THRESHOLD.value) * 100)

      // Riempi la progress bar in base allo scroll extra
      gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })

    if (extraScroll >= SCROLL_THRESHOLD.value ) {
      //console.log('dentro if extra scroll')
      // Cambia pagina e resetta il contatore
      gsap.to(baretta, {
        width: `100%`,
        duration: 0.1,
        onComplete: ()=>{
          isTransitioning.value = true;
            setTimeout(() => {
            router.push(localePath({name: 'team-slug', params: {slug: nextTeam.value.slug}}));
          }, 500)
        }
      })
      
       if (extraScrollPercentage.value >= 100) {
       
      }
       // Ritardo per l'animazione (0.5s corrisponde a .page-fade)
    }
  } else {
    // Resetta il contatore se l'utente scrolla verso l'alto o non è al fondo
    extraScroll = 0;
    extraScrollPercentage.value = 0
    gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })
  }
}
</script>
